import startCase from "lodash/startCase";
import lowerCase from "lodash/lowerCase";
import upperCase from "lodash/upperCase";

const ACRONYMS = ["API"];

/**
 * Converts from  snake case value (usually from enum) to display name.
 * Keeps acronyms capitalized.
 *
 * @param value - string, e.g. "TEST_API_VALUE"
 * @returns string, e.g. "Test API Value"
 */
export const snakeCaseToDisplay = (value: string) => {
  const displayName = startCase(lowerCase(value));

  return displayName
    .split(" ")
    .map((word) => {
      if (ACRONYMS.includes(upperCase(word))) {
        return upperCase(word);
      }
      return word;
    })
    .join(" ");
};

/**
 * Converts from  display name to snake case
 * @param value - string, e.g. "Test API Value"
 * @returns string, e.g. "TEST_API_VALUE"
 */
export const displayToSnakeCase = (value: string) => {
  return upperCase(value).split(" ").join("_");
};
